export default __webpack_public_path__ + "static/media/undraw_empty_cart_co35.498b68fd.svg";